import { lazy } from 'react';

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import { type PayFund } from '@webapp/models/PayFund'
import messages from './messages'
import { SpendingCardPhysicalCardTabs } from './SpendingCardPhysicalCardPage'

export interface SpendingCardFundDetailsPageParams {
  uuid: PayFund['uuid']
}

const SpendingCardFundDetailsViewChunk = lazy(() =>
  import('../containers/SpendingCardFundDetailsView').then(
    ({ SpendingCardFundDetailsView }) => ({
      default: SpendingCardFundDetailsView,
    })
  )
)

export const SpendingCardFundDetailsPage = () => {
  const intl = useProcurifyIntl()

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.spendingCardFundDetailsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.spendingCardPhysicalCardPageTitle),
          link: url('SpendingCardPhysicalCardPage', {
            tab: SpendingCardPhysicalCardTabs.OPEN,
          }),
        },
        {
          name: intl.formatMessage(messages.spendingCardFundDetailsPageTitle),
        },
      ]}
    >
      <SpendingCardFundDetailsViewChunk />
    </Page>
  )
}
